import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    id: Number
  }

  connect() {
    this.addEmbedIdToInput()
  }

  delete() {
    this.removeEmbedIdFromInput()
  }

  addEmbedIdToInput() {
    const input = this.element.closest('form')?.querySelector('input#post_embed_id')
    if (!input) { return }

    input.value = this.idValue
  }

  removeEmbedIdFromInput() {
    this.element.closest('form').querySelector('input#post_embed_id').value = ''
  }
}
